// src/pages/inventory/orders/OrdersPage.tsx
import React, { useState } from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/Layout";
import { PageContainer } from "../../../components/shared";
import SalesOrdersTab from "./sales-orders/content/SalesOrdersTab";
import PurchaseOrdersTab from "./purchase-orders/PurchaseOrdersTab";

type OrdersTabKey = "sales" | "purchases";

const OrdersPage: React.FC = () => {
	const [searchParams] = useSearchParams();
	// Read once on mount — tab switching is plain component state and never writes the
	// param back, so this is only an entry-point override (e.g. from the redirected
	// /inventory/purchases route), never a synced URL.
	const [activeTab] = useState<OrdersTabKey>(
		searchParams.get("tab") === "purchases" ? "purchases" : "sales"
	);

	const items = [
		{ key: "sales", label: "Sales Orders", children: <SalesOrdersTab /> },
		{ key: "purchases", label: "Purchase Orders", children: <PurchaseOrdersTab /> },
	];

	return (
		<Layout>
			<PageContainer>
				<Tabs defaultActiveKey={activeTab} items={items} />
			</PageContainer>
		</Layout>
	);
};

export default OrdersPage;
